module.exports = {};



//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0